import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Button, Icon } from 'antd';
import Flag from '../../components/Flag';
import { API_URL, COLLATERAL_TOTAL_AMOUNT, EXCHANGE_S3_IMAGE } from '../../config/constants';
import { getCountry } from '../../common/utils';

class FeaturedProject extends Component {
	render() {
		const { collateral, randomImage } = this.props;
		if (!collateral.info) {
			return (
				<div className="featured-project empty">
					<Icon type="frown" style={{ fontSize: '64px', color: '#000' }} />
					<h3>Empty</h3>
				</div>
			);
		}
		// const d = new Date();
		let height = 250;
		if (this.bannerBox) {
			height = this.bannerBox.offsetWidth / 2;
		}
		let bannerStyle = {
			backgroundImage: randomImage,
			height: `${height}px`
		};
		if (collateral.info.public && collateral.info.public.banner) {
			if (API_URL.includes('testnet')) {
				bannerStyle = {
					backgroundImage: `url(${EXCHANGE_S3_IMAGE('banner', collateral.name)})`
				};
			} else {
				bannerStyle = {
					backgroundImage: `url(${collateral.info.public.banner})`
				};
			}
		}
		let percent = 0;
		if (collateral.pledges) {
			const { amount } = collateral;
			const { total } = collateral.pledges;
			if (amount) {
				percent = (total / amount) * 100;
			} else {
				percent = (total / COLLATERAL_TOTAL_AMOUNT) * 100;
			}
		}
		let country = getCountry(collateral.info, true);
		const public_title = collateral.info.public
			? collateral.info.public.name
				? collateral.info.public.name
				: collateral.info.public.title
			: '';
		return (
			<div className="featured-project">
				<div>
					<h3>Featured Project</h3>
					<div style={bannerStyle} className="banner" ref={this.setRef}>
						{collateral.is_collateralized && <Flag />}
						<div className="progress-bar">
							<div
								className="mine"
								style={{
									left: `0%`,
									width: `${percent}%`
								}}
							></div>
						</div>
					</div>
				</div>
				<div>
					<div className="featured-project-info">
						<h3>{public_title}</h3>
						<p className="featured-project-desc">
							{collateral.info.public && collateral.info.public.description}
						</p>
						<p>
							<br />
							{country === '' ? (
								<span>
									<Icon
										type="global"
										style={{ fontSize: '11px', color: '#40A9FF' }}
									/>
									&nbsp;Global
								</span>
							) : (
								country
							)}
						</p>
					</div>
					<Button type="primary">
						<Link to={`/project/${collateral.id}`}>View Project</Link>
					</Button>
				</div>
			</div>
		);
	}
}

FeaturedProject.defaultProps = {
	pledges: {
		total: 0,
		mine: 0
	},
	name: ''
};

export default FeaturedProject;
